module.exports = __webpack_public_path__ + "static/media/viaappia_tn.f14bbda8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/viaappia_tn.jpg
// module id = 690
// module chunks = 0